module.exports = __webpack_public_path__ + "static/media/Student_Bulk_Upload.2808dbb7.xlsx";